'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _makeResourceTypeReducer = require('./makeResourceTypeReducer');

var _makeResourceTypeReducer2 = _interopRequireDefault(_makeResourceTypeReducer);

var _elementsResourceTypeReducer = require('../../../../../element/elementsResourceTypeReducer');

var _elementsResourceTypeReducer2 = _interopRequireDefault(_elementsResourceTypeReducer);

var _boardsResourceTypeReducer = require('../../../../../element/board/boardsResourceTypeReducer');

var _boardsResourceTypeReducer2 = _interopRequireDefault(_boardsResourceTypeReducer);

var _resourceConstants = require('../resourceConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Reducers
exports.default = (0, _reduxImmutable.combineReducers)({
    elements: _elementsResourceTypeReducer2.default,
    boards: _boardsResourceTypeReducer2.default,
    users: (0, _makeResourceTypeReducer2.default)(_resourceConstants.RESOURCE_TYPES.users)
});

// Constants
// Lib


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/http/resources/reducers/index.js
// module id = 2136
// module chunks = 0